import React from "react";
import { Header } from "../../components/header";
import { BigTitle, MyContainer } from "../../styles";
import { Idea } from "../../components/idea";

export const Research = () => {
    return (
        <>
        <Header page='research'/>
        <BigTitle>
            Projetos de Pesquisa
        </BigTitle>
        <MyContainer style={{textAlign:'center', marginBottom:'30px'}}>
            <iframe title="pesquisa" loading="lazy" scrolling="no" src="https://sigpesq.ifes.edu.br/web/projeto/publico.aspx" width="100%" height="2100px" frameborder="0" data-origwidth="100%" data-origheight="2100px" style={{width: '952px'}}></iframe>
            <Idea/>
        </MyContainer>
        </>
    )
}